<!-- <app-top-bar></app-top-bar> -->
<router-outlet></router-outlet>
<app-loading-module [isLoading]="appLoadingModuleService.isLoading"></app-loading-module>
<app-loading-overlay></app-loading-overlay>
<!--
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
-->

<!-- Dark mode in Taiga UI v4 is handled differently - TODO: implement new approach -->
<!-- @if(layoutService.themeMode$ | async; as mode){
  @if(mode === "dark") {
    <tui-theme-night />
  }
} -->

<tui-root>
  <!-- content of your app -->

  <!--
     If you need, you can add something between Taiga portal layers:
    -->
  <ng-container ngProjectAs="tuiOverContent">
    <!-- Content over app content -->
  </ng-container>
  <ng-container ngProjectAs="tuiOverDialogs">
    <!-- Content over dialogs -->
  </ng-container>
  <ng-container ngProjectAs="tuiOverAlerts">
    <!-- Content over alerts -->
  </ng-container>
  <ng-container ngProjectAs="tuiOverPortals">
    <!-- Content over dropdowns -->
  </ng-container>
  <ng-container ngProjectAs="tuiOverHints">
    <!-- Content over hints -->
  </ng-container>
</tui-root>
